
import "../HomePage/home.css"
import {useScrollContext} from "../../components/SmoothScroll/scroll-context";
import {useEffect} from "react";

export const ContactPage = ({}) => {
  const { updateScrollData, previous, current, rounding } = useScrollContext();

  useEffect(() => {
    updateScrollData({
      previous,
      current,
      rounding,
      ease: 1,
    })
  }, [])

  return (
    <div className="home-container">
      <div className="home-background" style={{backgroundColor: "#000000"}}/>
      <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: 150}}>
        <div className="text-container" style={{width: 500, padding: undefined, minWidth: 300}}>
          <span className="title" style={{width: 200}}>CONTACT US</span>
          <p className="text" style={{display: "inline-block", textAlign: "center", width: "100%"}}> You can contact us at&nbsp;<a
            href="mailto:support@projectskilltree.com">support@projectskilltree.com</a>.</p>
            <br/><br/>
            <p className="text" style={{display: "inline-block", textAlign: "center", width: "100%"}}>
              Please read our <a href={"./#/privacy"}>
              Privacy Policy</a>
              &nbsp;before sending product suggestions.</p>
        </div>
        <img src={require("../../images/background/quill.png")}
             style={{width: 200, objectFit: "contain"}}/>
      </div>
    </div>
  )
}
